import { AccessibilityLink } from "@faire/deprecated-retailer-visitor-shared/lib/AccessibilityLink";
import * as React from "react";
import { useEffect } from "react";
import { LinkProps } from "react-router-dom";

interface IHeaderLinkProps extends LinkProps {
  to: string;
  onMount?: () => void;
}

export const HeaderLinkBase: React.FC<IHeaderLinkProps> = (props) => {
  const { onMount, ...passThroughProps } = props;

  useEffect(() => {
    onMount?.();
  }, [onMount]);

  return <AccessibilityLink {...passThroughProps} />;
};
